export default "__VITE_ASSET__Cib_3H2d__"